<template lang="pug">
  div
    v-progress-circular(
      v-if="loading"
      indeterminate
      color="primary")     
    .card(v-if="!loading && !editing")
      v-row
        v-col
        v-col
        v-col
          .funding {{card.funding}}
      v-row
        v-col
          .number **** **** **** {{ card.last4 || card.dynamic_last4}}
      v-row
        v-col
        v-col
          .exp {{ `${card.exp_month}/${card.exp_year}`}}
      v-row
        v-col
        v-col
        v-col
          .funding {{card.brand}}    
    .editing-card(v-show="!loading && editing")
      v-row
        v-col          
      v-row
        v-col
          div(id="card-element")
    div {{message}}
</template>
<script>
export default {
  data() {
    return {
      card: {},
      loading: false,
      stripe: null,
      cardElement: null,
      customer: null,
      message: null
    }
  },
  props: {
    editing: {
      type: Boolean,
      default: false
    }    
  },
  created() {    
    this.customerGet();
  },  
  methods: {
    customerGet() {
      this.loading = true;
      this.$store.dispatch("customerGet").then(response => {
        if(response.status === 200) {
          this.card = response.data.paymentSource;
          this.customer = response.data;
          this.stripe = window.Stripe('pk_test_51HJiaJAjczOwzQiTCe3MnYuAnbRjyzEz1o4urAeiudQEO8jJA2RKOcSyoiBWvxIhCiqUdOd6BpyUZ0xPq0ETyUYc00lUyV6QQf');
          const elements = this.stripe.elements();
          this.cardElement = elements.create('card');
          this.cardElement.mount('#card-element');
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    addCard() {
      this.loading = true;
      this.message = null;
      this.stripe.createSource(        
          this.cardElement, {
            type: 'card'
          }
          // details: {
          //   name: `${$this.customerNUFI.firstName} ${$this.customerNUFI.lastName}`,
          //   email: $this.customerNUFI.email,
          //   phone: $this.customerNUFI.phone                    
          //   }
          // }
        
      ).then(response => {
        if (response.error) {          
          this.message = response.error.message;
          this.loading = false;
        } else {          
          this.customer.paymentSource.Id = response.source.id;
          this.$store.dispatch("customerAttachCard", this.customer).then(response2 => {
            if(response2) {              
              this.customerGet();
              this.$emit("updated");
              this.loading = false;
            }
          })          
        }
        
      });
    }
  },
}
</script>
<style scoped>
  .card {
    width: 300px;
    height: 180px;
    background-color: lightsteelblue;
    border-radius: 10px;
    text-transform: uppercase;
    padding: 15px;    
  }
  .editing-card {
    width: 100%;
    height: 62px;
    line-height: 80px;
    background-color: lightsteelblue;
    border-radius: 10px;
    text-transform: uppercase;
    padding: 12px;    
  }
  .number {
    width: 100%;    
    text-align: center;
    line-height: 40px;
    font-size: 22px;
    color:azure;
    letter-spacing: 3px;
    margin-top: 14px;
  }
  .exp {
    font-size: 12px;
    text-align: right;
  }
  .funding {
    text-align: right;
  }
</style>